export default [
  {
    id: "home",
    to: "/",
    scrollTo: "#home"
  },
  {
    id: "video",
    to: "/#video",
    scrollTo: "#video"
  },
  {
    id: "info",
    to: "/#info",
    scrollTo: "#info"
  },
  {
    id: "team",
    to: "/#team",
    scrollTo: "#team"
  },
  {
    id: "contact",
    to: "/#contact",
    scrollTo: "#contact"
  }
]